var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShuruCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M9.305 1.396h-4.61L3.55 3.469l-.675.058A2.093 2.093 0 0 0 .991 5.296C.864 6.156.75 7.042.75 7.947c0 .905.114 1.791.241 2.652.14.95.928 1.686 1.884 1.769 1.372.118 2.747.236 4.125.236 1.378 0 2.753-.118 4.125-.236a2.093 2.093 0 0 0 1.884-1.77c.127-.86.241-1.746.241-2.65 0-.906-.114-1.792-.241-2.652a2.093 2.093 0 0 0-1.884-1.77l-.675-.057-1.145-2.073Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7 9.902a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuruCamera);
export default __webpack_public_path__ + "static/media/shuru_camera.23f684987aca5c85c78e43f0002624f2.svg";
export { ForwardRef as ReactComponent };